import { message } from "utilities/message/message";
import { err, ok } from "utilities/result";
import {
  type SubmitVerificationAttemptPayload,
  verificationPlanResponseSchema,
} from "../types/Verification";

const requestPlan = async (permissions: string[] = []) => {
  const [response, error] = await message("create-verification-plan", {
    permissions,
  });

  if (error) {
    return err(error);
  }

  if (!response) {
    return err(new Error("No response, please refresh and try again."));
  }

  const parsed = verificationPlanResponseSchema.safeParse(response.data);

  if (!parsed.success) {
    return err(
      new Error("Unexpected response format, please refresh and try again."),
    );
  }

  return ok(parsed.data);
};

const submitAttemptData = async (payload: SubmitVerificationAttemptPayload) => {
  const [response, error] = await message(
    "submit-verification-attempt-data",
    payload,
  );

  if (error) {
    return err(error);
  }

  return ok(response);
};

export const verificationService = { requestPlan, submitAttemptData };
